var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "labelStyle" },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Estado:",
                  content:
                    _vm.dadosJson.localizacao.municipio.codigoEstado || "-"
                }
              })
            ],
            1
          ),
          _vm.dadosJson.localizacao.geometrias &&
          _vm.dadosJson.localizacao.geometrias.length
            ? _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "div",
                  { staticClass: "pad" },
                  [
                    _c("app-resumo-mapa", {
                      attrs: {
                        idMapa: "id-mapa-localizacao-uc",
                        height: 30,
                        localizacoes: _vm.dadosJson.localizacao.geometrias,
                        isVisualizarCadastro: true
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f7604054", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7604054","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/LocalizacaoUc.vue
// module id = null
// module chunks = 